import React from 'react';

import { Element } from 'domhandler';
import parse, { DOMNode, domToReact } from 'html-react-parser';

import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';

export const convertHtmlToReactElement = (
  html: string,
  tagsToReplace: string[] = ['a', 'p'],
): string | React.JSX.Element | React.JSX.Element[] => {
  const result = parse(html, {
    replace: domNode => {
      if (tagsToReplace.includes((domNode as Element).name)) {
        switch ((domNode as Element).name) {
          case 'a':
            return (
              <ExternalLink target="_blank" href={(domNode as Element).attribs.href}>
                {domToReact((domNode as Element).children as DOMNode[])}
              </ExternalLink>
            );
          case 'p':
            return <>{domToReact((domNode as Element).children as DOMNode[])}</>;
          default:
            return domNode;
        }
      }
      return domNode;
    },
  });
  return result;
};
